import './CompanyLeftSection.css'

interface iCompanyLeftSection {
  title: string;
  image: string
}

export const CompanyLeftSection = ({title,image}:iCompanyLeftSection) => {
  return (
    <>
      <h3 className='me-5  pb-5 fw-500'>
        {title}
      </h3>
      <div className='position-relative m-0 mt-0 img-container'>
        <div className='square'></div>
        <img className='m-0' src={image} alt="businessman professional" />
      </div>
    </>
  );
}